import {SET_SAMPLE} from 'constants/action-types.js';
import {NEW_SEQUENCE} from 'constants/action-types.js';

const samplesReducer = (state = {}, action) => {
    switch (action.type) {
    case NEW_SEQUENCE:
        return {};
    case SET_SAMPLE:
        let newState = Object.assign({}, state);
        newState[action.payload.sampleId] = action.payload.sample;
        return newState;
    default:
        return state;
    }
};

export default samplesReducer;
